import { useCompanyBaseInfoQuery } from "app/pages/sales-intelligence/modules/company-analysis/queries/useCompanyBaseInfoQuery";
import useCurrentStateAndParamsWithFixedDomain from "app/pages/sales-intelligence/sub-modules/account-overview/shared/hooks/useCurrentStateAndParamsWithFixedDomain";

export const useCompanyName = (): string => {
    const {
        params: { key: domain },
    } = useCurrentStateAndParamsWithFixedDomain();
    const { data: company } = useCompanyBaseInfoQuery(domain);

    return company?.name || "";
};
